import { all, takeLatest, call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { differenceInDays, parseISO } from 'date-fns';

import api from '../../../services/api';
import {
  getTimestampConfigsSuccess,
  updateTimestampConfigSuccess,
  renotarizationsFailure,
} from './actions';
import { refreshTokenRequest } from '../auth/actions';
import { store } from '../../index';
import { date } from '../../../utils/dateFormatter';
import { responseErrors } from '../../../utils/responseErros';

const UPDATE_ERROR_TITLE = 'Falha ao atualizar configuração de renotarização';

export function* getTimestampConfigs({ payload }) {
  const { refresh_token } = store.getState().auth;

  try {
    const { query } = payload;
    const response = yield call(api.get, '/management/timestamp-configs', {
      params: query,
    });
    yield put(getTimestampConfigsSuccess(response.data));
  } catch (err) {
    if (err.response.status === 403) {
      yield put(refreshTokenRequest(refresh_token));
    } else {
      yield put(renotarizationsFailure());
      toast.error('Falha ao listar configurações de renotarização');
    }
  }
}

export function* updateTimestampConfig({ payload }) {
  const { refresh_token } = store.getState().auth;

  try {
    const { id, data, index, onSuccess } = payload;
    const days = Number(data.renotorizationLimitInDays);

    if (days > -1) {
      // A listagem vem ordenada por lastSeen (mais recente primeiro)
      const { data: timestamps } = yield call(
        api.get,
        '/management/timestamps',
        { params: { page: 1, limit: 10 } }
      );
      const currentTimestamp = timestamps?.content?.rows?.[0];

      if (!currentTimestamp) {
        yield put(renotarizationsFailure());
        Swal.fire({
          icon: 'error',
          title: UPDATE_ERROR_TITLE,
          text: 'Nenhum carimbo de tempo em uso encontrado.',
        });
        return;
      }

      const maxDays = differenceInDays(
        parseISO(currentTimestamp.expiration),
        new Date()
      );
      if (days > maxDays) {
        yield put(renotarizationsFailure());
        Swal.fire({
          icon: 'error',
          title: UPDATE_ERROR_TITLE,
          text: `O prazo de renotarização não pode ultrapassar a expiração do carimbo atual (${date(
            currentTimestamp.expiration
          )}). Máximo permitido: ${maxDays} dias.`,
        });
        return;
      }
    }

    const response = yield call(
      api.patch,
      `/management/timestamp-configs/${id}`,
      data
    );
    yield put(updateTimestampConfigSuccess(index, response.data));
    if (onSuccess) onSuccess();
    toast.success('Configuração atualizada com sucesso');
  } catch (err) {
    if (err.response?.status === 403) {
      yield put(refreshTokenRequest(refresh_token));
    } else {
      yield put(renotarizationsFailure());
      Swal.fire(responseErrors(err.response, UPDATE_ERROR_TITLE));
    }
  }
}

export default all([
  takeLatest(
    '@renotarizations/GET_TIMESTAMP_CONFIGS_REQUEST',
    getTimestampConfigs
  ),
  takeLatest(
    '@renotarizations/UPDATE_TIMESTAMP_CONFIG_REQUEST',
    updateTimestampConfig
  ),
]);
